import Raven from 'raven-js'
import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import queryString from 'query-string'

import config from 'config'
import { api } from './api'
import * as actions from './actions'
import * as UserActions from 'modules/user/actions'
import * as MetricsActions from 'modules/metrics/actions'
import { countAppMetric } from 'utils/metrics'

const regenerateCode = (action$) => {
  return action$
    .ofType(actions.regenerateCode.toString())
    .mergeMap(() => {
      return api
        .regenerateCode()
        .map(actions.regenerateCodeSuccess)
        .startWith(actions.regenerateCodePending())
        .catch((error) => {
          return Observable.of(actions.regenerateCodeFailed(error))
        })
    })
}

const countRegenerateCodeFailure = (action$, store) => {
  return action$
    .ofType(actions.regenerateCodeFailed.toString())
    .pluck('payload')
    .map((error) => {
      Raven.captureException(error, { logger: 'tracking-signup' })

      return MetricsActions.sendDriftAppMetric(countAppMetric('regenerateCode.failed'))
    })
}

const regenerateCodeSuccess = (action$) => {
  return action$
    .ofType(actions.regenerateCodeSuccess.toString())
    .pluck('payload')
    .map(({ authorizationCode }) => {
      const videoLoginCallbackUrl =  `${config.DRIFT_VIDEO_HOMEPAGE}/accounts/login/callback-drift?${queryString.stringify({
        code: authorizationCode,
      })}`

      localStorage.setItem('video_signup_completed', true)

      return UserActions.updateUserProperties({
        properties: {
          videoSignUpDone: true,
        },
        redirectUrl: videoLoginCallbackUrl,
      })
    })
}

export const epic = combineEpics(
  regenerateCode,
  regenerateCodeSuccess,
  countRegenerateCodeFailure
)
